import { __rest } from "tslib";
// import React from 'react'
import React, { useState, useEffect } from 'react';
import { default as IS_CLIENT } from "@pb/utils/constants/isClient";
import cn from 'classnames';
import { IconButton } from "../CTA";
import { ArrowLeftIcon } from "../Icon";
import styles from './BackToTop.module.scss';
const BackToTop = (_a) => {
    var { label, className } = _a, props = __rest(_a, ["label", "className"]);
    const [isVisible, setIsVisible] = useState(false);
    const [isOnTop, setIsOnTop] = useState(false);
    const FOCUSABLE_ELEMENT_SELECTORS = 'a, button:not([disabled]), [tabindex="0"]';
    const focusableElements = IS_CLIENT && document.querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS);
    const HTMLFocusableElements = [];
    if (focusableElements) {
        focusableElements.forEach((el) => {
            if (el instanceof HTMLElement) {
                HTMLFocusableElements.push(el);
            }
        });
    }
    useEffect(() => {
        if (isOnTop && HTMLFocusableElements.length) {
            HTMLFocusableElements[0].focus();
            HTMLFocusableElements[0].blur();
        }
    }, [isOnTop]);
    const onScrollToTop = () => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    };
    useEffect(() => {
        const innerHeightTimesTwo = window.innerHeight * 2;
        let oldScrollY = window.scrollY;
        const scrollListener = () => {
            if (oldScrollY < window.scrollY) {
                setIsVisible(false);
            }
            else {
                setIsVisible(true);
            }
            oldScrollY = window.scrollY;
            if (oldScrollY < innerHeightTimesTwo)
                setIsVisible(false);
            if (window.scrollY === 0) {
                setIsOnTop(true);
            }
            else {
                setIsOnTop(false);
            }
        };
        window.addEventListener('scroll', scrollListener);
        return () => window.removeEventListener('scroll', scrollListener);
    }, []);
    if (!isVisible) {
        return null;
    }
    return (React.createElement(IconButton, Object.assign({ "data-testid": "back-to-top", Tag: "button", className: cn(styles.button, className), onClick: onScrollToTop, iconElement: React.createElement(ArrowLeftIcon, { className: styles.icon, size: "small" }) }, props), label));
};
export default BackToTop;
//# sourceMappingURL=BackToTop.js.map